export default "__VITE_ASSET__BpQBUcII__"